import {
  apiDeleteClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid,
  apiPostClinicalStudiesAssociationMedicalData,
  apiPostMedicaldata,
  VisitAvailableMedicalData,
} from "../../../api";
import { useSupportedMedicalData } from "../../../catalogs/supported-medical-data";
import { getServerNowISO } from "../../../utils/server-time";
import { useSoftAssert } from "../../../utils/use-soft-assert";
import { BasicMedicalTable } from "../medical/basic-medical-table";
import { Patient } from "../patient";
import { BaseDataVisitField, Submittable } from "./base-data-visit-field";

export function MedicalDataVisitField(props: {
  prefill: VisitAvailableMedicalData;
  patient: Patient;
  ref: (h: Submittable) => void;
  visitUuid: string;
}) {
  const supportedMedData = useSupportedMedicalData();
  const variableInfo = supportedMedData.find(
    (d) => d.data_name === props.prefill.data_definition.data_name,
  );

  if (!useSoftAssert(variableInfo, "Medical data definition not found")) {
    return null;
  }

  return (
    <BaseDataVisitField
      associatedData={props.prefill.associated_data}
      existingData={props.prefill.existing_data}
      patient={props.patient}
      valueSelector={(d) => d.measurement_value}
      variableInfo={variableInfo}
      ref={props.ref}
      existingDataTable={(p) => (
        <BasicMedicalTable
          api={props.patient.api}
          patient={props.patient}
          disableEdit
          disableHistory
          disablePagination
          canSelect="multi"
          {...p}
        />
      )}
      onSubmit={async ({ newValue, editedValue, addedUuids, removedUuids }) => {
        if (editedValue) {
          await props.patient.updateItem("medicaldata", editedValue.uuid, {
            measurement_value: editedValue.value,
          });
        }

        if (newValue != null) {
          await apiPostMedicaldata({
            body: {
              patient_id: props.patient.patientId,
              measurement_value: newValue as any,
              measurement_type: props.prefill.data_definition.data_name,
              measurement_unit: variableInfo.primary_unit,
              measurement_datetime: getServerNowISO(),
              study_visit_link: props.visitUuid,
            },
          });
        }

        if (addedUuids && addedUuids.length > 0) {
          await apiPostClinicalStudiesAssociationMedicalData({
            body: {
              number_of_datapoints: addedUuids.length,
              associations: addedUuids.map((uuid) => ({
                medical_data_uuid: uuid,
                study_visit_uuid: props.visitUuid,
              })),
            },
          });
        }

        for (const uuid of removedUuids ?? []) {
          await apiDeleteClinicalStudiesAssociationMedicalDataMedicalDataUuidVisitUuid(
            { path: { medical_data_uuid: uuid, visit_uuid: props.visitUuid } },
          );
        }
      }}
    />
  );
}
